// ============================================
// src/features/dashboard/hooks/useDashboardPermissions.ts
// ============================================

import { usePermissions } from 'react-admin';

export interface UseDashboardPermissionsResult {
  canViewDashboard: boolean;
  canSelectHotel: boolean;
  canViewAdvancedMetrics: boolean;
  canExportData: boolean;
  userRole: string;
}

export const useDashboardPermissions = (): UseDashboardPermissionsResult => {
  const { permissions: role } = usePermissions();
  
  return {
    canViewDashboard: true, // All authenticated users can view dashboard
    canSelectHotel: role === 'SuperAdmin' || role === 'GroupAdmin',
    canViewAdvancedMetrics: role !== 'Receptionist',
    canExportData: role === 'SuperAdmin' || role === 'GroupAdmin' || role === 'HotelAdmin',
    userRole: role || 'User',
  };
};